<template>
    <div id="timer" class="timer">
        <div v-if="days" class="day">
            <span class="number">{{ days }}</span>
            <div class="format">Dias</div>
        </div>
        <div class="hour">
            <span class="number">{{ hours }}</span>
            <div class="format">Horas</div>
        </div>
        <div class="min">
            <span class="number">{{ minutes }}</span>
            <div class="format">Minutos</div>
        </div>
        <div class="sec">
            <span class="number">{{ seconds }}</span>
            <div class="format">Segundos</div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'SurveyTimer',
    props: {
        starttime: String,
        endtime: String
    },
    data () {
        return {
            timer: '',
            start: '',
            end: '',
            interval: '',
            days: '',
            minutes: '',
            hours: '',
            seconds: '',
            statusType: '',
            statusText: ''
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedSurveyObject'
        ]),
        choices () {
            return this.question.choices.map((choice) => {
                return { text: choice.body, value: choice.id }
            })
        }
    },
    methods: {
        ...mapActions([
            'updateStudentSurveyAnswer'
        ]),
        timerCount (start, end) {
            // Get todays date and time
            var now = new Date().getTime()

            // Find the distance between now an the count down date
            var distance = start - now
            var passTime = end - now

            if (distance < 0 && passTime < 0) {
                this.statusType = 'expired'
                this.statusText = 'expired'
                clearInterval(this.interval)
                this.$emit('timer-expired')
            } else if (distance < 0 && passTime > 0) {
                this.calcTime(passTime)
                this.statusType = 'running'
                this.statusText = 'running'
            } else if (distance > 0 && passTime > 0) {
                this.calcTime(distance)
                this.statusType = 'upcoming'
                this.statusText = 'upcoming'
            }
        },
        calcTime (dist) {
            // Time calculations for days, hours, minutes and seconds
            this.days = Math.floor(dist / (1000 * 60 * 60 * 24))
            this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60))
            this.seconds = Math.floor((dist % (1000 * 60)) / 1000)
        }
    },
    mounted () {
        this.start = new Date(this.starttime).getTime()
        this.end = new Date(this.endtime).getTime()
        // Update the count down every 1 second
        this.timerCount(this.start, this.end)
        this.interval = setInterval(() => {
            this.timerCount(this.start, this.end)
        }, 1000)
    }
}
</script>

<style lang="scss" scoped>
.timer {
    font-size: 20px;
    color: #fff;
    text-align: center;
    margin-top: 20px;

    .day,
    .hour,
    .min,
    .sec {
        font-size: 30px;
        display: inline-block;
        font-weight: 500;
        text-align: center;
        margin: 0 5px;
        .format {
            font-weight: 300;
            font-size: 14px;
            color: #222;
            //@include margin-start(5);
            //display: inline-block;
            opacity: 0.8;
            width: 60px;
        }
    }
    .number {
        background: rgba(51, 51, 51, 0.53);
        padding: 0 5px;
        border-radius: 5px;
        display: inline-block;
        width: 60px;
        text-align: center;
    }
    .status-tag {
        width: 270px;
        margin: 10px auto;
        padding: 8px 0;
        font-weight: 500;
        color: #000;
        text-align: center;
        border-radius: 15px;
        &.upcoming {
            background-color: lightGreen;
        }
        &.running {
            background-color: gold;
        }
        &.expired {
            background-color: silver;
        }
    }
}
</style>
